<div class="filter-container">
    <input
        type="text"
        [(ngModel)]="text"
        (input)="onInputChange()"
        [placeholder]="placeholder"
        class="filter-input" />
    <button *ngIf="text" class="clear-btn" (click)="clear()" title="Limpiar">
        ✕
    </button>
</div>
